<template>
  <label class="flex w-fit items-center">
    <input
      v-model="value"
      type="checkbox"
      class="peer cursor-pointer appearance-none rounded-md border-lightSecondaryColor bg-lightSecondaryColor p-xs shadow-inner shadow-gray-300 checked:border-[4px] checked:bg-primary checked:p-[6px] checked:shadow-none dark:border-neutral-900 dark:bg-neutral-900 dark:shadow-black dark:checked:bg-primary"
      :class="{
        'isInTabsComponent:!border-lightPrimaryColor isInTabsComponent:!bg-lightPrimaryColor isInTabsComponent:shadow-none isInTabsComponent:checked:!bg-primary dark:isInTabsComponent:!border-neutral-900 dark:isInTabsComponent:!bg-neutral-900 dark:isInTabsComponent:checked:!bg-primary': true,
        'disabled:!cursor-not-allowed disabled:!bg-opacity-60 disabled:!shadow-none': true,
        'ring-1 !ring-red': errors,
      }"
      v-bind="$attrs"
      @change="clearErrors"
    />
    <span
      class="cursor-pointer pl-2 peer-disabled:pointer-events-none peer-disabled:text-lightTertiaryColor peer-disabled:dark:text-darkTertiaryColor"
    >
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script setup lang="ts" generic="T">
import { InputHTMLAttributes } from "vue";

import { useErrors } from "../errors/useErrors";

type Props = {
  label?: string;
} & /* @vue-ignore */ InputHTMLAttributes;
defineProps<Props>();
const value = defineModel<undefined | T>();

const { errors, clearErrors } = useErrors();
</script>
